import { Modal, ModalBody, ModalFooter, ModalHeader } from "design-react-kit";
import React from "react";
import ReactDOM from "react-dom";
import { Button } from "reactstrap";
interface CustomModalProps {
  isOpen: boolean;
  toggleModal: Function;
  titleModal: string;
  closeButtonText: string;
  sendButtonText: string;
  closeAction: Function;
  sendAction: Function;
  sendButtonColor: string;
  isLoading: boolean;
}
const CustomModal: React.FC<CustomModalProps> = ({
  isOpen,
  toggleModal,
  titleModal,
  closeButtonText,
  sendButtonText,
  closeAction,
  sendAction,
  children,
  isLoading,
  sendButtonColor
}) => {
  const portal = document.getElementById("react-portal");
  if (portal) {
    return ReactDOM.createPortal(
      <Modal
        isOpen={isOpen}
        toggle={() => toggleModal(!isOpen)}
        centered
        labelledBy="esempio9">
        <ModalHeader toggle={() => toggleModal(!isOpen)} id="essempio9">
          {titleModal}
        </ModalHeader>
        <ModalBody>{children}</ModalBody>
        <ModalFooter>
          <Button disabled={isLoading} color="secondary" onClick={() => closeAction()}>
            {closeButtonText}
          </Button>
          <Button disabled={isLoading} color={sendButtonColor} onClick={() => sendAction()}>
            {sendButtonText}
          </Button>
        </ModalFooter>
      </Modal>,
      portal
    );
  }
  return <></>;
};

export default CustomModal;
